/* eslint-disable */
import { withStyles } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import curry from 'lodash/curry';
import isEmpty from 'lodash/isEmpty';
import Infinite from 'react-infinite';
import some from 'lodash/some';
import moment from 'moment';
import React, {useState, useEffect, useRef} from 'react';
import {
  ORDER_MAX_DAYS_FROM_TODAY,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_NEW,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
} from '../../Constants/Order/Order.constants';
import generateHash from '../../Support/Generators/GenerateHash/GeneratorsGenerateHash.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import DateText from '../DateText/DateText.component';
import OrderCard from '../OrderCard/OrderCard.component';
import orderGroupStyles from './OrderGroup.component.styles';

/* eslint-disable react/no-array-index-key */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/prop-types */

const defaultOrderStatuses = [
  ORDER_STATUS_TO_BE_CONFIRMED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_NEW,
];

/**
 * OrderGroupCards
 * @param {Object} orders orders
 * @returns {React.SFC<OrderGroupCardsProps>} component
 */
const OrderGroupCards = ({ classes, orders }) => {
  return orders.map(({ orderKey, ...order }) => (
    <ListItem classes={{ dense: classNames(classes.spaceBetween, classes.cursorPointer) }} disableGutters key={generateHash(order)}>
      <OrderCard orderId={orderKey} />
    </ListItem>
  ));
};

const conditional = curry((conditionFunction, ComponentWhenTrue, ComponentWhenFalse) => (conditionFunction ? ComponentWhenTrue : ComponentWhenFalse));

/**
 * EmptyOrders
 * @param {Object} orders orders
 * @returns {React.SFC<EmptyOrdersProps>} component
 */
const EmptyOrders = ({ classes, isLoading, filters }) => {
  const noOrdersMessage = `You do not have any orders on this date`;
  const noOrdersByFilterMessage = `No orders for the selected filters`;
  const { orderStatus, addresses } = filters;
  const statusFiltered = orderStatus.length !== defaultOrderStatuses.length && orderStatus.length !== 0;
  const addressFiltered = some(addresses, Boolean);
  const isFiltered = statusFiltered || addressFiltered;
  const message = isFiltered ? noOrdersByFilterMessage : noOrdersMessage;
  return (
    <ListItem classes={{ dense: classes.spaceBetween }} disableGutters>
      <div>
        <Typography className={classes.noOrdersText}>{isLoading ? `Loading...` : message}</Typography>
      </div>
    </ListItem>
  );
};

/**
 * OrderGroupComponent
 * @param {OrderGroupComponentProps} props props
 * @returns {React.SFC<OrderGroupComponentProps>} component
 */
const OrderGroupComponent = ({ classes, orderGroup, ordersLoading, filters }) => {

  const [containerHeight, setContainerHeight] = useState(100);
  const containerRef = useRef();

  useEffect(()=>{
    setContainerHeight(containerRef.current.parentElement.parentElement.parentElement.clientHeight);
  },[]);

  const orders = orderGroup.filter(({ date }) => !moment(date).isAfter(moment().add(ORDER_MAX_DAYS_FROM_TODAY, `days`)));

  // calculate height of element based on number of orders
  const heights=orders.map((el) => {
    if(!el.orders.length) {
      return 166; // 64 for heading is included in this but need to test if margin bottom 70 also needs to be included as well as check if instead of 64 need to be 56 included for mobiles
    }
    return (el.orders.length * 159) + 134; // previously was +64 but this was causing weird behaviour when scrolled to the bottom, dates changed and slightly scrolled up so added 70px for margin bottom on the group hence 134
  });

  return (<div ref={containerRef}><Infinite elementHeight={heights} containerHeight={containerHeight}>
    {orders
      .map(({ date, orders }, i) => (
        <div className={classes.groupContainer} key={generateHash(date)}>
          <ListSubheader classes={{ root: classes.subHeader }}>
            <DateText date={date} />
          </ListSubheader>
          {conditional(
            isEmpty(orders),
            <EmptyOrders classes={classes} filters={filters} isLoading={ordersLoading} />,
            <OrderGroupCards classes={classes} orders={orders} />,
          )}
        </div>
      ))}</Infinite></div>
  );
};

const OrderGroup = withStyles(themeCreateInjectableStyles(orderGroupStyles), { withTheme: true })(OrderGroupComponent);

export default OrderGroup;
